import React, { useState, useEffect } from 'react';
import { VOTER_ORANGE, voterIcons } from '../../component/voterCardIcons';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import { useAppId } from "../../context/AppIdContext";
import '../../style/adminList.css';
import '../../style/speakSearch.css';
import Header from '../../component/header';
import WhatsappSlipButton from '../../component/WhatsappSlipButton';
import PracharButton from '../../component/PracharButton';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const DateWiseSlipSendingVoters = () => {
    // --- Router & Context State ---
    const { appId, language, userId } = useAppId();
    const location = useLocation();
    const navigate = useNavigate();

    // Extract date from the navigation state
    const passedDate = location.state?.date;

    // --- Logic State ---
    const [voters, setVoters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    // --- Pagination State ---
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    const lang = language || 'en';

    // Translation dictionary mapped for Date Wise
    const t = {
        en: {
            title: "Date Wise Voters",
            subtitle: "List of voters whose slips were sent on this date.",
            searchPlaceholder: "Search by name or mobile...",
            noRecordsFound: "No voters found matching",
            loadingText: "Fetching Records...",
            fatherHusband: "F/S :",
            serialNo: "Sr No. :",
            mobile: "Mobile :",
            idCardNo: "ID Card No :",
            boothNo: "Booth No :",
            houseNo: "House No :",
            pollingLoc: "Voting Loc :",
            slipCount: "Slips Sent :",
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            family: "Family",
            btnSearch: "Search",
            back: "Back to Dashboard",
            familyError: "Could not fetch family details.",
            print: "Print",
            address: "Address :",
            editMobileTitle: "Update Mobile Number",
        mobilePlaceholder: "Enter 10-digit mobile number",
        mobileErrorLength: "Mobile number must be 10 digits",
        mobileErrorStart: "Number must start with 6, 7, 8, or 9",
        cancel: "Cancel",
        save: "Save",
        saving: "Saving...",
        mobileUpdateSuccess: "Mobile number updated successfully!",
        mobileUpdateFailed: "Failed to update mobile number.",
        mobileUpdateError: "An error occurred while updating the mobile number.",
        mobileNotAvailable: "Mobile number is not available for this voter.",
        addressNotAvailable: "Address not available!"

        },
        hi: {
            title: "तिथि वार मतदाता",
            subtitle: "उन मतदाताओं की सूची जिनकी पर्चियां इस तिथि को भेजी गई थीं।",
            searchPlaceholder: "नाम या मोबाइल से खोजें...",
            noRecordsFound: "कोई मतदाता नहीं मिला",
            loadingText: "रिकॉर्ड प्राप्त कर रहे हैं...",
            fatherHusband: "पिता/पति :",
            serialNo: "क्रमांक :",
            mobile: "मोबाइल :",
            idCardNo: "पहचान पत्र नं.:",
            boothNo: "बूथ नं :",
            houseNo: "घर नं :",
            pollingLoc: "मतदान स्थान :",
            slipCount: "पर्ची भेजी गई :",
            call: "कॉल",
            text: "मैसेज",
            slip: "पर्ची",
            prachar: "प्रचार",
            family: "परिवार",
            btnSearch: "खोजें",
            back: "डैशबोर्ड पर वापस जाएं",
            familyError: "परिवार का विवरण प्राप्त नहीं किया जा सका।",
            print: "प्रिन्ट",
            editMobileTitle: "मोबाइल नंबर अपडेट करें",
        mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
        mobileErrorLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
        mobileErrorStart: "नंबर 6, 7, 8, या 9 से शुरू होना चाहिए",
        cancel: "रद्द करें",
        save: "सेव करें",
        saving: "सेव हो रहा है...",
        mobileUpdateSuccess: "मोबाइल नंबर सफलतापूर्वक अपडेट हो गया!",
        mobileUpdateFailed: "मोबाइल नंबर अपडेट करने में विफल।",
        mobileUpdateError: "मोबाइल नंबर अपडेट करते समय एक त्रुटि हुई।",
        mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",	
        addressNotAvailable: "पता उपलब्ध नहीं है!"	

        },
        gu: {
            title: "તારીખ મુજબ મતદારો",
            subtitle: "મતદારોની યાદી જેમની સ્લિપ આ તારીખે મોકલવામાં આવી હતી.",
            searchPlaceholder: "નામ અથવા મોબાઇલ દ્વારા શોધો...",
            noRecordsFound: "કોઈ મતદાર મળ્યો નથી",
            loadingText: "રેકોર્ડ મેળવી રહ્યા છે...",
            fatherHusband: "પિતા/પતિ :",
            serialNo: "ક્રમાંક :",
            mobile: "મોબાઇલ :",
            idCardNo: "ઓળખ કાર્ડ નં :",
            boothNo: "બૂથ નં :",
            houseNo: "ઘર નં :",
            pollingLoc: "મતદાન સ્થળ :",
            slipCount: "સ્લિપ મોકલેલ :",
            call: "કૉલ",
            text: "સંદેશ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            family: "કુટુંબ",
            btnSearch: "શોધો",
            back: "ડેશબોર્ડ પર પાછા જાઓ",
            familyError: "કુટુંબની વિગતો મેળવી શકાઈ નહીં.",
            print: "Print",
            address: "સરનામું :",
            editMobileTitle: "મોબાઇલ નંબર અપડેટ કરો",
        mobilePlaceholder: "10 અંકોનો મોબાઇલ નંબર દાખલ કરો",
        mobileErrorLength: "મોબાઇલ નંબર 10 અંકોનો હોવો જોઈએ",
        mobileErrorStart: "નંબર 6, 7, 8, અથવા 9 થી શરૂ થવો જોઈએ",
        cancel: "રદ કરો",
        save: "સેવ કરો",
        saving: "સેવ થઈ રહ્યું છે...",
        mobileUpdateSuccess: "મોબાઇલ નંબર સફળતાપૂર્વક અપડેટ થયો!",
        mobileUpdateFailed: "મોબાઇલ નંબર અપડેટ કરવામાં નિષ્ફળ.",
        mobileUpdateError: "મોબાઇલ નંબર અપડેટ કરતી વખતે એક ભૂલ આવી.",
        mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
        addressNotAvailable: "સરનામું ઉપલબ્ધ નથી!"

        }
    };

    const txt = t[lang] || t['en'];
    // --- Edit Mobile State ---
    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);



    // --- Edit Mobile API Call ---
const handleUpdateMobile = async () => {
    if (!newMobile || newMobile.length !== 10) {
        alert(txt.mobileErrorLength);
        return;
    }

    setIsSavingMobile(true);
    try {
        const payload = {
            app_id: appId?.toString(),
            voter_id: editingVoter.idcard_no,
            mobile_no: newMobile,
            modify_by: userId?.toString() || "1"
        };	

        const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

        if (response.data.success || response.data.Success === "1") {
            alert(txt.mobileUpdateSuccess);
            setVoters(prev => prev.map(v =>
                v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
            ));
            setIsEditMobileOpen(false);
        } else {
            alert(txt.mobileUpdateFailed);
        }
    } catch (error) {
        console.error("Error updating mobile:", error);
        alert(txt.mobileUpdateError);
    } finally {
        setIsSavingMobile(false);
    }
};


    // --- API Fetching ---
    useEffect(() => {
        if (!appId) {
            navigate('/login');
            return;
        }
        if (passedDate) {
            fetchVotersData();
        } else {
            setLoading(false);
        }
    }, [appId, passedDate]);

    const fetchVotersData = async () => {
        setLoading(true);
        setCurrentPage(1);
        try {
            const response = await axios.post(
                `${BASE_URL}/api/date_wise_slip_sending_voter`,
                {
                    app_id: appId,
                    date: passedDate
                }
            );

            if (response.data.success && response.data.data && response.data.data.result) {
                setVoters(response.data.data.result);
            } else {
                setVoters([]);
            }
        } catch (err) {
            console.error("API Error:", err);
            setVoters([]);
        } finally {
            setLoading(false);
        }
    };

    // --- WhatsApp Message Generation Logic ---
    const handleWhatsAppShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');

            } else {
                alert("Could not fetch family details.");
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert("Error generating message.");
        }
    };

    // --- SMS Message Generation Logic ---
    const handleSmsShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');

                // Open native SMS app with pre-filled body
                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert("Could not fetch family details for SMS.");
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert("Error generating SMS message.");
        }
    };

    // --- Filter Logic ---
    const filteredVoters = voters.filter(voter => {
        if (!searchTerm) return true;
        const lowerSearch = searchTerm.toLowerCase();

        const fullName = [voter.eng_f_name, voter.eng_m_name, voter.eng_surname].filter(Boolean).join(" ").toLowerCase();

        return (
            fullName.includes(lowerSearch) ||
            (voter.idcard_no && voter.idcard_no.toLowerCase().includes(lowerSearch)) ||
            (voter.contact_no && String(voter.contact_no).includes(lowerSearch))
        );
    });

    // --- Pagination Logic ---
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentVoters = filteredVoters.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredVoters.length / itemsPerPage);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalPages <= maxVisibleButtons) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            if (currentPage <= 3) endPage = 4;
            if (currentPage >= totalPages - 2) startPage = totalPages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalPages - 1) pageNumbers.push('...');
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            // Trigger filter (already handled by real-time filter, but keeps UX consistent)
        }
    };

    return (
        <div className='app-container p-4'>

            <Header title={txt.title} />

            {/* Mobile Number Edit Modal */}
{isEditMobileOpen && (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsEditMobileOpen(false)}>
        <div className="slide-up-element" style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '350px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }} onClick={(e) => e.stopPropagation()}>
            <h4 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#0f172a', fontWeight: '700' }}>{txt.editMobileTitle}</h4>
            <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>{editingVoter?.eng_f_name} {editingVoter?.eng_surname}</p>

            <div style={{ marginBottom: '24px' }}>
                <input
                    type="tel"
                    maxLength="10"
                    value={newMobile}
                    onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                    style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: (newMobile && !/^[6-9]\d{9}$/.test(newMobile) && newMobile.length === 10) ? '1px solid #ef4444' : '1px solid #cbd5e1',
                        borderRadius: '10px',
                        fontSize: '15px',
                        outline: 'none',
                        boxSizing: 'border-box'
                    }}
                    placeholder={txt.mobilePlaceholder}
                    autoFocus
                />
                {newMobile && newMobile.length > 0 && !/^[6-9]\d{9}$/.test(newMobile) && (
                    <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '6px', fontWeight: '500' }}>
                        {newMobile.length < 10 ? txt.mobileErrorLength : txt.mobileErrorStart}
                    </div>
                )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                <button
                    onClick={() => setIsEditMobileOpen(false)}
                    style={{ padding: '10px 16px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}
                >
                    {txt.cancel}
                </button>
                <button
                    onClick={handleUpdateMobile}
                    disabled={isSavingMobile || !/^[6-9]\d{9}$/.test(newMobile)}
                    style={{
                        padding: '10px 20px',
                        background: (!/^[6-9]\d{9}$/.test(newMobile)) ? '#94a3b8' : '#2563eb',
                        color: 'white',
                        border: 'none',
                        borderRadius: '10px',
                        cursor: (!/^[6-9]\d{9}$/.test(newMobile)) ? 'not-allowed' : 'pointer',
                        fontWeight: '600'
                    }}
                >
                    {isSavingMobile ? txt.saving : txt.save}
                </button>
            </div>
        </div>
    </div>
)}


            {passedDate && !loading && (
                <div className="mb-3 text-primary fw-bold mt-2" style={{ fontSize: '1.1rem' }}>
                    Date: {passedDate}
                </div>
            )}

            {/* --- PROFESSIONAL FILTER CONTAINER --- */}
            <div className="filter-container mt-3">
                <div className="search-wrapper">
                    <svg className="search-icon-main" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <input
                        type="text"
                        className="search-input"
                        placeholder={txt.searchPlaceholder}
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1); // Reset to first page on search
                        }}
                        onKeyDown={handleKeyDown}
                        style={{ paddingRight: '50px' }}
                    />
                </div>

                <div className="count-display-modern slide-up-element">
                    <span className="count-label">{lang === 'en' ? 'Total :' : (lang === 'hi' ? 'कुल :' : 'કુલ :')}</span>
                    <span className="count-number">{filteredVoters.length}</span>
                </div>
            </div>

            {/* --- Loading State --- */}
            {loading && (
                <div className="loader-wrapper">
                    <div className="spinner"></div>
                    <p className="loader-text">{txt.loadingText}</p>
                </div>
            )}

            {/* --- Results Grid --- */}
            <div className="row g-4 mt-1 pb-5">
                {!loading && currentVoters.length > 0 ? (
                    currentVoters.map((voter, index) => {
                        return (
                            <div className="col-12 col-md-6 col-lg-4 slide-up-element" key={voter.id || index} style={{ animationDelay: `${index * 0.05}s` }}>
                                <div className="voter-card-clean h-100">
                                    <div className="voter-header">
                                        <span className="serial-number">{indexOfFirstItem + index + 1}.</span>
                                        <span className="voter-name-bold ms-2">{voter.eng_f_name} {voter.eng_surname}</span>
                                    </div>
                                    <div className="voter-body position-relative">
                                <div className="info-row"><span className="label">{txt.fatherHusband}</span><span className="value">{voter.eng_m_name || "N/A"}</span></div>
                                        <div className="info-row"><span className="label">{txt.address}</span><span className="value">{voter.eng_localityid || "N/A"}</span></div>
                                        <div className="info-row"><span className="label">{txt.serialNo}</span><span className="value">{voter.slnoinpart || "N/A"}</span></div>
                                        <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                            <span className="label">{txt.mobile}</span>
                                            <span className="value mobile-value" style={{ flexGrow: 1 }}>{voter.contact_no || "N/A"}</span>
                                            <svg
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setEditingVoter(voter);
                                                    setNewMobile(voter.contact_no || '');
                                                    setIsEditMobileOpen(true);
                                                }}
                                                style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                                fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                            </svg>
                                        </div>
                                        <div className="info-row"><span className="label">{txt.idCardNo}</span><span className="value">{voter.idcard_no || "N/A"}</span></div>
                                        <div className="info-row"><span className="label">{txt.boothNo}</span><span className="value">{voter.part_no || "N/A"}</span></div>
                                        <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{voter.eng_house_no || "N/A"}</span></div>
                                        <div className="info-row"><span className="label">{txt.pollingLoc}</span><span className="value">{voter.eng_polling_location || "-"}</span></div>

                                        {/* Status / Slip Sent Count */}
                                        <div className="info-row mt-2 pt-2" style={{ borderTop: '1px dashed #e2e8f0' }}>
                                            <span className="label">{txt.slipCount}</span>
                                            <span className="value text-success font-weight-bold">{voter.sleep_count || "0"}</span>
                                        </div>
                                    </div>
                                    <div className="voter-actions">
                                        <ActionButton icon={voterIcons.call} color={VOTER_ORANGE} label={txt.call}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (!voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
                                                    alert("Mobile number is not available for this voter.");
                                                }
                                                else {
                                                    window.open(`tel:${voter.contact_no}`, '_blank');
                                                }
                                            }}

                                        />
                                        <ActionButton icon={voterIcons.text} color={VOTER_ORANGE} label={txt.text} onClick={() => handleSmsShare(voter)} />
                                        <WhatsappSlipButton voter={voter} />
                                        <PracharButton voter={voter} />
                                        <ActionButton
                                            icon={voterIcons.print} color={VOTER_ORANGE}
                                            label={txt.print}
                                            onClick={() => navigate('/printer', { state: { voter_id: voter.id } })}
                                        />
                                        <ActionButton icon={voterIcons.family} color={VOTER_ORANGE} label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: voter.id } })} />
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    !loading && (
                        <div className="col-12 text-center text-muted p-5">
                            {txt.noRecordsFound} "{searchTerm}"
                        </div>
                    )
                )}
            </div>

            {/* --- Pagination --- */}
            {!loading && filteredVoters.length > itemsPerPage && (
                <div className="pagination-wrapper">
                    <div className="pagination-content">
                        <button className="pagination-nav-btn" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                        </button>
                        <div className="page-numbers">
                            {getPageNumbers().map((number, index) => (
                                <React.Fragment key={index}>
                                    {number === '...' ? (<span className="page-dots">...</span>) : (
                                        <button className={`page-num-btn ${currentPage === number ? 'active' : ''}`} onClick={() => paginate(number)}>{number}</button>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                        <button className="pagination-nav-btn" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                        </button>
                    </div>
                </div>
            )}

            <style jsx>{`
                .app-container { background: #E5E7EB; min-height: 100vh; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }
                @keyframes slideInUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
                .slide-up-element { opacity: 0; animation: slideInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
                
                /* --- COUNT DISPLAY --- */
                .count-display-modern { display: inline-flex; align-items: center; background: #eff6ff; padding: 8px 16px; border-radius: 12px; border: 1px solid #bfdbfe; box-shadow: 0 2px 4px rgba(37, 99, 235, 0.05); gap: 8px; }
                .count-label { color: #1e40af; font-weight: 600; font-size: 15px; }
                .count-number { background: transparent; color: #1d4ed8; font-weight: 800; font-size: 16px; }

                .filter-container { display: flex; justify-content: space-between; align-items: center; gap: 16px; margin-bottom: 24px; background: transparent; flex-wrap: wrap; }
                .search-wrapper { position: relative; flex: 1; max-width: 450px; }
                .search-icon-main { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); color: #94a3b8; width: 20px; height: 20px; z-index: 1; }
                .search-input { width: 100%; padding: 12px 60px 12px 42px; border: 1px solid #e2e8f0; border-radius: 10px; font-size: 14px; color: #1e293b; outline: none; transition: all 0.2s ease; box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
                .search-input:focus { border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); }
                
                .search-btn-icon { position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: #2563eb; border: none; border-radius: 8px; cursor: pointer; color: white; padding: 8px 12px; display: flex; align-items: center; justify-content: center; transition: 0.2s; z-index: 2; }
                .search-btn-icon:hover { background-color: #1d4ed8; }
                .search-btn-icon:disabled { background-color: #94a3b8; cursor: not-allowed; }
                .spinner-icon { animation: spin 1s linear infinite; }
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                
                .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 60vh; width: 100%; }
                .spinner { width: 40px; height: 40px; border: 4px solid #E5E7EB; border-top: 4px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 12px; }
                .loader-text { color: #6B7280; font-weight: 500; }
                
                .text-success { color: #059669 !important; }
                .text-warning { color: #d97706 !important; }
                .font-weight-bold { font-weight: 700 !important; }

                /* Pagination */
                .pagination-wrapper { display: flex; justify-content: center; padding: 20px 0; position: sticky; bottom: 20px; z-index: 50; }
                .pagination-content { background: white; border: 1px solid #E2E8F0; border-radius: 50px; padding: 6px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); }
                .pagination-nav-btn { display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%; background: transparent; border: none; color: #2563EB; cursor: pointer; }
                .pagination-nav-btn:disabled { color: #CBD5E1; cursor: not-allowed; }
                .page-numbers { display: flex; gap: 4px; align-items: center; }
                .page-num-btn { width: 30px; height: 30px; border-radius: 50%; border: none; background: transparent; color: #475569; font-weight: 600; font-size: 13px; cursor: pointer; }
                .page-num-btn.active { background-color: #2563EB; color: white; }
                
                /* Mobile Optimization */
                @media (max-width: 640px) { 
                    .filter-container { width: 100%; }
                    .search-wrapper { width: 100%; max-width: 100%; }
                    .search-input { padding: 10px 50px 10px 36px; font-size: 13px; }
                    .search-icon-main { left: 10px; width: 16px; height: 16px; }
                    .search-btn-icon { right: 6px; padding: 6px 10px; }
                    .row.g-4 { margin-left: -8px; margin-right: -8px; }
                    [class*="col-"] { padding-left: 8px; padding-right: 8px; }
                }
            `}</style>
        </div>
    );
};

// Reusable ActionButton
const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default DateWiseSlipSendingVoters;